<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        title
      }}</span>
      <div
        class="close-button cursor-pointer"
        role="button"
        :aria-label="General.CLOSE"
        @click.stop="hasCancelAction ? $emit('close') : denyAction()"
      >
        <b-icon icon="close" :type="isContrast ? 'is-white-dark' : ''" />
      </div>
    </header>

    <div class="modal-content-container">
      <b-icon
        v-if="iconName"
        class="is-align-self-center my-20"
        :icon="iconName"
        size="is-large"
        customSize="mdi-60px"
        :type="isContrast ? 'is-white-dark' : 'is-grey'"
      ></b-icon>

      <div
        data-cy="WARNING_MESSAGE"
        class="has-text-color-8 spacing-px-20 py-10"
        :class="{ 'has-text-centered': isMessageCentered }"
        v-html="message"
      ></div>

      <footer class="modal-card-foot">
        <div class="action-buttons">
          <b-button
            v-for="(button, index) in buttons"
            :key="index"
            :data-cy="button.dataCY"
            :type="isContrast ? 'is-white-dark' : getColorButton(button)"
            class="is-medium"
            :expanded="isMobile"
            :class="{ 'is-outlined': isOutlined(button.isConfirm) }"
            @click="() => (button.action ? confirmAction() : denyAction())"
          >
            {{ button.label }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { General } from "@/utils/constants";

export default {
  name: "ModalWarning",

  props: {
    title: {
      type: String,
      default: General.WARNING
    },
    message: {
      type: String,
      default: ""
    },
    confirm: {
      type: Function,
      default: () => null
    },
    deny: {
      type: Function,
      default: () => null
    },
    buttons: {
      type: Array,
      default: () => [
        { label: General.YES, isConfirm: true, action: true },
        { label: General.NO, isConfirm: false, action: false }
      ]
    },
    isMessageCentered: {
      type: Boolean,
      default: false
    },
    invertOutline: {
      type: Boolean,
      default: false
    },
    hasCancelAction: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      General,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({
      isContrast: "isContrast",
      isMobile: "isMobile"
    })
  },

  methods: {
    async confirmAction() {
      this.isLoading = true;
      await this.confirm();
      this.isLoading = false;
      this.close();
    },

    async denyAction() {
      this.isLoading = true;
      await this.deny();
      this.isLoading = false;
      this.close();
    },

    close() {
      this.$parent.close();
    },

    isOutlined(outline) {
      return this.invertOutline ? !outline : outline;
    },

    getColorButton(button) {
      return button.isConfirm ? "is-green-lawn" : "is-orange";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  max-height: 75vh;
  background-color: $color-1;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
  color: $dark-white;
}
.modal-card-foot {
  display: flex;
  justify-content: flex-end;

  @media screen and (max-width: $tablet) {
    justify-content: center;
  }

  .action-buttons {
    @media screen and (max-width: $tablet) {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1;
    }
  }
}
</style>
